import {
  AssetType,
  BorrowerOnboardingDetails,
  getIncomeById,
  Income,
  Loan,
  OnboardingDetailsRole,
} from '@nemuru-eng/js-api-client';
import { useEffect, useState } from 'react';

import { StoredBorrowerOnboardingDetails } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/types';
import { BorrowerOnboardingDetailsMap } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/MerchantPosForm/components/BorrowerOnboardingDetailsForm/maps/borrowerOnboardingDetails.map';
import { useCache } from '@/hooks/requests/useCache';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface UseBorrowerOnboardingDetailsProps {
  loan: Loan;
  borrowerOnboardingDetails: BorrowerOnboardingDetails;
  role: OnboardingDetailsRole;
}

export const useBorrowerOnboardingDetails = ({
  loan,
  borrowerOnboardingDetails,
  role,
}: UseBorrowerOnboardingDetailsProps) => {
  const {
    data: income,
    loading,
    revalidate: revalidateIncome,
  } = useCache(getIncomeById, {
    loanId: loan.id,
    onboardingDetailsId: borrowerOnboardingDetails.id,
  });
  const { themeName } = useCustomTheme();
  const isAutoLoan = loan.assetReference[0].type === AssetType.AUTO;

  const [borrowerOnboardingDetailsWithIncome, setBorrowerOnboardingDetailsWithIncome] = useState<
    StoredBorrowerOnboardingDetails | undefined
  >(undefined);

  useEffect(() => {
    if (income) {
      setBorrowerOnboardingDetailsFromLoan(income);
    }
  }, [income, loan]);

  const setBorrowerOnboardingDetailsFromLoan = async (income: Income) => {
    try {
      const mappedLoanOnboardingDetails = BorrowerOnboardingDetailsMap.fromLoanOnboardingDetailsToForm(
        borrowerOnboardingDetails,
        income,
        loan.borrowerCashInCashOutMethodAccountNumber,
      );

      if (!mappedLoanOnboardingDetails) return;

      const details = BorrowerOnboardingDetailsMap.fromFormToStored(
        mappedLoanOnboardingDetails,
        role,
        loan.loanConditions.currency,
        themeName,
        isAutoLoan,
      );

      setBorrowerOnboardingDetailsWithIncome({
        ...details,
        nieData: details.nieData ?? borrowerOnboardingDetails.nieData,
      });
    } catch (error) {
      console.error(error);
    }
  };

  return { borrowerOnboardingDetailsWithIncome, loading, revalidateIncome };
};
